import _ from 'lodash'
import { useMemo } from 'react'

import type { Consultation } from '@/core/models/consultation.model'
import type { Staff } from '@/core/models/staff.model'

type UseParticipantsParams = {
  consultation?: Consultation
  participants?: Staff[]
}

export function useParticipants({ consultation, participants }: UseParticipantsParams) {
  const isDoctorOnline = useMemo(() => {
    if (!participants || !consultation || !consultation.medecin) return false
    return !!participants.find((participant) => participant._id === consultation?.medecin?._id)
  }, [participants, consultation])

  const isPdsOnline = useMemo(() => {
    if (!participants || !consultation) return false
    return !!participants.find((participant) => participant._id === consultation?.pds?._id)
  }, [participants, consultation])

  const doctor = _.trim(`${consultation?.medecin?.userInfo.surname || ''} ${consultation?.medecin?.userInfo.name || ''}`)
  const pds = _.trim(`${consultation?.pds?.userInfo.surname || ''} ${consultation?.pds?.userInfo.name || ''}`)

  return {
    isDoctorOnline,
    isPdsOnline,
    doctor,
    pds,
  }
}
